import { Input } from '@mui/joy';
import SearchIcon from '@mui/icons-material/Search';

function SearchInput({ value, onChange, placeholder = 'Поиск...' }) {
  return (
    <Input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      startDecorator={<SearchIcon />}
      sx={{ minWidth: 220, flex: 1 }}
    />
  );
}

export default SearchInput;
